import React, { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Button, Icon, TextField } from 'investira.react.components';
import { BaseTemplate } from '../../../components/templates';
import withMessage from '../../../hoc/withMessage';

const AvaliacoesSettingsModeloEdit = memo(props => {
  const navigate = useNavigate();

  const [titulo, setTitulo] = useState('');
  const [descricao, setDescricao] = useState('');

  const handleSave = () => {
    if (!titulo.trim()) {
      props.onMessageError?.('Informe o título do modelo.');
      return;
    }

    const xPayload = {
      titulo: titulo.trim(),
      descricao: descricao.trim()
    };

    console.log('novo modelo', xPayload);
    props.onMessageSuccess?.('Modelo criado com sucesso.');
    navigate('/avaliacoes/configuracoes/modelos');
  };

  return (
    <BaseTemplate
      title={'Editar Modelo'}
      subtitle={'Configurações'}
      description="Utilize modelos para padronizar critérios e estruturar avaliações personalizadas de acordo com as necessidades da sua estratégia. Esses modelos serão a base para organizar as questões e atribuir pesos, facilitando a análise dos resultados."
      maxWidth={'md'}
      headerRenderActions={
        <Stack direction="row" spacing={2}>
          <Button
            disabled={props.disabledButtons}
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="upload" size={16} />}
            size="small"
            sx={{ px: 2 }}
            onClick={handleSave}>
            Salvar
          </Button>
        </Stack>
      }>
      <Stack gap={2} py={3}>
        <TextField
          label="Título"
          placeholder="Ex.: Modelo Conservador"
          value={titulo}
          onChange={pEvent => setTitulo(pEvent.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
          variant="outlined"
        />

        <TextField
          label="Descrição"
          placeholder="Descreva o objetivo deste modelo"
          value={descricao}
          onChange={pEvent => setDescricao(pEvent.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          multiline
          rows={4}
        />
      </Stack>
    </BaseTemplate>
  );
});

AvaliacoesSettingsModeloEdit.displayName = 'AvaliacoesSettingsModeloEdit';

export default withMessage(AvaliacoesSettingsModeloEdit);
